import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/v2";

const DialogErrorForFutureReservationsInDeletion = ({ dialog }) => {
	return (
		<DialogAlertErrorSimple
			dialog={dialog}
			title="No se puede eliminar el espacio"
			content="Actualmente el espacio cuenta con reservas, para eliminarlo, debes validar que no exista ninguna reserva vigente o futura." />
	);
}

export default DialogErrorForFutureReservationsInDeletion;